import intl from 'react-intl-universal';
import AppDispatcher from '../dispatcher/AppDispatcher';
import PackConstants from '../constants/PackConstants';
import PackAPI from '../utils/PackAPI';
import Popup from 'react-popup'

function deselectOrder(order_id) {
  if(order_id){
      PackAPI.releaseOrder(order_id)
  }
  AppDispatcher.dispatch({
    actionType: PackConstants.DESELECT_ORDER
  });
}

function recieveOrder(kod, uid, pakowalnia_id, pack, multi_order_id = false) {
  PackAPI
    .getOrder(kod, uid, pakowalnia_id, pack, multi_order_id)
    .then(order => {
      if (typeof order == 'object' && 'already_scannned' in order){
        Popup.create({
          content: intl.get('Istnieje prawdopodobieństwo, że to zamówienie jest otwarte na innej pakowalni. \nNa pewno chcesz przejść do zamówienia?'),
          buttons: {
            right: [{
              text: 'Tak',
              action: function () {
                Popup.close()
                recieveOrder('', uid, pakowalnia_id, pack, order.already_scannned)
              }
            },
            {
              text: 'Anuluj',
              className: 'cancel-button',
              action: function () {
                Popup.close()
                deselectOrder()
              }
            }]
          }
        })
      } else {
        AppDispatcher.dispatch({
          actionType: PackConstants.RECIEVE_ORDER,
          order: JSON.parse(order)
        });
      }
    })
    .catch(message => {
      AppDispatcher.dispatch({
        actionType: PackConstants.RECIEVE_ORDER_ERROR,
        message: message
      });
    });
}

export default {

  recievePacks: (uid, pakowalnia_id) => {
    PackAPI
      .getPacks(uid, pakowalnia_id)
      .then(packs => {
        AppDispatcher.dispatch({
          actionType: PackConstants.RECIEVE_PACKS,
          packs: packs
        });
      })
      .catch(message => {
        AppDispatcher.dispatch({
          actionType: PackConstants.RECIEVE_PACKS_ERROR,
          message: message
        });
      });
  },

  selectPack: (pack) => {
    AppDispatcher.dispatch({
      actionType: PackConstants.SELECT_PACK,
      pack: pack
    });
  },

  selectVariant: (code) => {
    AppDispatcher.dispatch({
      actionType: PackConstants.SELECT_VARIANT,
      code: code
    });
  },

  deselectOrder,

  getVariants: (kod, uid, pakowalnia_id, pack) => {
    AppDispatcher.dispatch({
      actionType: PackConstants.SCAN_PRODUCT,
      code: kod
    })
    PackAPI
      .getVariants(kod, uid, pakowalnia_id, pack)
      .then(variants => {
        AppDispatcher.dispatch({
          actionType: PackConstants.RECIEVE_VARIANTS,
          variants: variants
        });
      })
      .catch(message => {
        AppDispatcher.dispatch({
          actionType: PackConstants.RECIEVE_VARIANTS_ERROR,
          message: message
        });
      });
  },

  getCart: (kod, uid, pakowalnia_id) => {
    PackAPI
      .getCart(kod, uid, pakowalnia_id)
      .then(pack => {
        AppDispatcher.dispatch({
          actionType: PackConstants.SELECT_PACK,
          pack: pack,
          from_search: true
        });
      })
      .catch(message => {
        AppDispatcher.dispatch({
          actionType: PackConstants.GET_CART_ERROR,
          message: message
        });
      });
  },

  recieveOrder,

  processPakowanie: (values) => {
    PackAPI
      .processPakowanie(values)
      .then(res => {
        AppDispatcher.dispatch({
          actionType: PackConstants.PROCESS_PAKOWANIE,
          result: res
        });
      })
      .catch(message => {
        AppDispatcher.dispatch({
          actionType: PackConstants.PROCESS_PAKOWANIE_ERROR,
          message: message
        });
      });
  },

  recieveMultipack: (pack, uid) => {
    PackAPI
    .recieveMultipack(pack, uid)
    .then(boxes => {
      AppDispatcher.dispatch({
        actionType: PackConstants.RECIEVE_MULTIPACK,
        boxes: boxes
      });
    })
    .catch(message => {
      AppDispatcher.dispatch({
        actionType: PackConstants.RECIEVE_MULTIPACK_ERROR,
        message: message
      });
    });
  },

  addPackage: (order, carrier, uid, pakowalnia_id, inpost_size) => {
    PackAPI
    .addPackage(order, carrier, uid, pakowalnia_id, inpost_size)
    .then(res => {
      AppDispatcher.dispatch({
        actionType: PackConstants.ADD_PACKAGE,
        res: res
      });
    })
    .catch(message => {
      AppDispatcher.dispatch({
        actionType: PackConstants.ADD_PACKAGE_ERROR,
        message: message
      });
    });
  },

  addDelivery: (order, carrier, uid, pakowalnia_id) => {
    PackAPI
    .addDelivery(order, carrier, uid, pakowalnia_id)
    .then(res => {
      AppDispatcher.dispatch({
        actionType: PackConstants.ADD_DELIVERY,
        res: res
      });
    })
    .catch(message => {
      AppDispatcher.dispatch({
        actionType: PackConstants.ADD_DELIVERY_ERROR,
        message: message
      });
    });
  },

  printLabelAgain: (order, pakowalnia_id) => {
    PackAPI
    .printLabelAgain(order, pakowalnia_id)
    .then(res => {
      AppDispatcher.dispatch({
        actionType: PackConstants.PRINT_LABEL,
        res: res
      });
    })
    .catch(message => {
      AppDispatcher.dispatch({
        actionType: PackConstants.PRINT_LABEL_ERROR,
        message: message
      });
    });
  },

  printInvoice: (order, uid, pakowalnia_id) => {
    PackAPI
    .printInvoice(order, uid, pakowalnia_id)
    .then(res => {
      AppDispatcher.dispatch({
        actionType: PackConstants.PRINT_INVOICE,
        res: res
      });
    })
    .catch(message => {
      AppDispatcher.dispatch({
        actionType: PackConstants.PRINT_INVOICE_ERROR,
        message: message
      });
    });
  },

  confirmDone: () => {
    AppDispatcher.dispatch({
      actionType: PackConstants.CONFIRM_DONE
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/PackActions.js